import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListQueryPaginationPayload } from '@app-store/slices/companies/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventType.list

// This saga is for getting list of companies
function* listSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            ...payload.pagination,
            query: payload.query
        }

        const response = yield axios.get(`/event/event-type`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSagaTask)
}

export default listSaga
